import { render, staticRenderFns } from "./AdvertiserSingleWrap.vue?vue&type=template&id=d6488936&scoped=true&"
import script from "./AdvertiserSingleWrap.vue?vue&type=script&lang=ts&"
export * from "./AdvertiserSingleWrap.vue?vue&type=script&lang=ts&"
import style0 from "./AdvertiserSingleWrap.vue?vue&type=style&index=0&id=d6488936&prod&lang=scss&"
import style1 from "./AdvertiserSingleWrap.vue?vue&type=style&index=1&id=d6488936&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6488936",
  null
  
)

export default component.exports